import { IAppTranslations } from "lib/translations/interfaces/translations.interface";
import LanguagePicker from "./components/language-picker.component";
import UserMenu from "./components/user-menu.component";
import "./styles/participant-header.styles.scss";

export default function ParticipantHeader({translations}: {translations: IAppTranslations}) {
    const enableMobileMenuSmall: boolean = false;
    return (
        <>
            <div className="app-header header-shadow">
                <div className="app-header__logo">
                    <div className="mrg-logo-src" />
                </div>
                <div className={`app-header__content ${enableMobileMenuSmall ? 'header-mobile-open' : ''}`} style={{ padding: 0 }}>
                    <div className="app-header-right">
                        <UserMenu translations={translations} />

                        <div className="header-dots">
                            <LanguagePicker />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}